<div class="modal-inner-container">
    <h1>Cancel Sharing?</h1>
    <p>Your selections will not be sent.</p>
    <button matButton="outlined" class="cancel-btn" mat-dialog-close>Cancel Sharing</button>
    <button matButton="outlined" mat-dialog-close>Keep Sharing</button>
</div>